import React, { useContext } from 'react'
import { MdClose } from 'react-icons/md'
import "./cartitem.css"
import { Context } from '../../../utils/context'

function CartItem() {
  const {cartItems, handleRemoveFromCart, handleProductQuantity} = useContext(Context)
  return (
    <div className="cart-prods">
      {cartItems.map((item: any) => (
        <div key={item.id} className="cart-sprod">
          <div className="cart-prod-img">
            <img src={item?.attributes?.img?.data[0]?.attributes?.url} alt="" />
          </div>
          <div className="cart-item-details">
            <span className="cart-item-name">{item.attributes.title}</span>
            <MdClose className='close-btn' onClick={() => handleRemoveFromCart(item)}/>
            <div className="qty-btn">
              <span onClick={() => handleProductQuantity("dec",item)}>-</span>
              <span>{item.attributes.quantity}</span>
              <span onClick={() => handleProductQuantity("inc",item)}>+</span>
            </div>
            <div className="cart-item-text">
              <span>{item.attributes.quantity} </span>
              <span>x</span>
              <span style={{color: "#5917f3"}}>&#8377;{item.attributes.price * item.attributes.quantity}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CartItem
